import { render } from "./ChatHistory.vue?vue&type=template&id=af20f20a&scoped=true"
import script from "./ChatHistory.vue?vue&type=script&lang=js"
export * from "./ChatHistory.vue?vue&type=script&lang=js"

import "./ChatHistory.vue?vue&type=style&index=0&id=af20f20a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-af20f20a"]])

export default __exports__